<template>
  <div class="create-form view-form fh">
    <div class="fh center" v-if="loading">
      <loading-circle />
    </div>
    <div v-else class="fh">
      <div class="create-form--nav view-form--nav module-header v-center space-between">
      <div class="flex gap-1">
        <img
            src="~@/assets/images/icons/arrow-back.svg"
            width="20"
            class="go-back"
            @click="goBack"
          />
          <div>
            <h2 class="module-name v-center">
              {{ formTemplateData?.name }} <div class="form-type"> <span class="header-default-dot">.</span> {{ formTemplateData?.core_form_type?.name }}</div>
            </h2>
          <!-- <div v-if="templateField" class="form-header-default">
              <span class="header-default-label">Created <span class="header-default-value">{{ getValuesFromForm('created_by') }}</span></span>
              <span class="header-default-label"> <span class="header-default-dot">.</span><span class="header-default-value">{{ getValuesFromForm('created_on') }}</span></span> &ensp;
              <span class="header-default-label" v-if="getValuesFromForm('updated_by')"> Updated <span class="header-default-value">{{ getValuesFromForm('updated_by') }}</span></span>
              <span class="header-default-label" v-if="getValuesFromForm('updated_by')"> <span class="header-default-dot">.</span><span class="header-default-value">{{ getValuesFromForm('updated_on') }}</span></span>
            </div> -->
          </div>
    </div>
        <div class="v-center flex-end py-3">
          <button class="btn btn-cancel mx-2" @click="goBack" @keypress="goBack">
            Cancel
          </button>
          <!--  parentFormId is there then no need of draft, its reopned form  -->
          <button
            v-if="!parentFormId"
            class="btn mr-2"
            @click="saveAsDraft"
            :disabled="disableSubmit"
          >
            Save as draft
          </button>
          <button
            class="btn btn"
            @click="checkEmptyUserStepAndSubmit()"
            :disabled="disableSubmit"
          >
            Submit
          </button>
        </div>
      </div>
      <div :class="['create-form--maincontainer view-form--maincontainer',{'no-wf-container' : !showSideBar}]">
        <div class="create-form--container view-form--container">
          <div class="create-form--elements view-form--elements">
             <!-- <div class="create-form-autogenerated form-autogenerated" v-if="!materialId">
               <div v-if="formData.sequence_value" class="autogenerated span-div">
                <span class="label">Sequence ID</span>
                <span class="value">
                  {{ formData.sequence_value }}
                </span>
              </div>
              <template v-for="(ele, index) in templateField">
                <div
                  :key="index"
                  v-if="
                    ele.autogenerated &&
                    ele.field_name !== 'project' &&
                    ele.field_id !== config.FACTORY_FIELD_ID
                  "
                  class="span-div"
                >
                  <span class="label">{{ ele.caption }}:</span>
                  <span class="value">{{ "--" }}</span>
                </div>
              </template>
            </div> -->
            <div class="mb-1">
              <part-id-preview
                :components="partIdRules"
                v-if="partIdRules.length && !formData.sequence_value"
                @update="updatePartIdValues"
                title="Sequence Id Preview"
              />
            </div>
            <div class="form-grid">
              <div class="form-grid__item" :class="getComponentGridClass('DATE')">
                <div
                  :class="{
                    dateComponent: true,
                    'form-input': true,
                    'form-input--required': true,
                    'form-input--explicit-asterisk': true
                  }" data-validation="dueDate">
                    <label class="form-input__label">
                      <span class="form-input__caption">Due Date<span class="form-input__asterisk">*</span></span>
                    </label>
                  <input
                    v-model="dueDate"
                    type="date"
                    placeholder="Search"
                    :min="currentDate"
                  />

                </div>
              </div>
              <template v-for="(ele, index) in templateField">
                <div
                  v-if="ele.field_id === config.FACTORY_FIELD_ID"
                  :key="index"
                  :class="['form-grid__item', getComponentGridClass(ele.form_field?.key)]"
                >
                  <factory-component
                    :value="formValueData[ele.field_id]"
                    :ref="ele.field_id"
                    :viewOnly="false"
                    mode="CREATE"
                    :data="ele"
                  />
                </div>
                <div
                  v-else-if="
                    !ele.autogenerated &&
                    (ele.form_field.key !== 'BOM' || isOnProjectLevel)
                  "
                  :key="ele.field_id"
                  :class="['form-grid__item', getComponentGridClass(ele.form_field.key)]"
                >
                  <component
                    :ref="ele.field_id"
                    :fieldId="ele.field_id"
                    :viewOnly="false"
                    :formTypeId="formTemplateData.core_form_type.id"
                    :is="ele.form_field.key + '_COMPONENT'"
                    :data="ele"
                    :value="formValueData[ele.field_id]"
                    :formTemplate="true"
                    :isFormMode="ele.form_field.key === 'TABLE'"
                    @saveasDraftForFB="saveasDraftForFB"
                    mode="CREATE"
                  />
                </div>
              </template>
            </div>
          </div>
        </div>
        <div
          class="create-form--sideBar view-form--sideBar"
          v-if="showSideBar"
        >
          <div class="tab-headers">
            <div
              v-for="(tab, index) in visibleTabs"
              :key="index"
              :class="['tab-header', { active: selectedTab === tab.id }]"
              @click="selectedTab = tab.id"
            >
              {{ tab.name }}
            </div>
          </div>
          <div
            v-if="
              (selectedTab === config.FORM_TAB_STATUS.REVISION_HISTORY ||
                selectedTab === config.FORM_TAB_STATUS.HISTORY) &&
              parentFormId
            "
            class="tab-body-parent"
          >
            <version-history
              :rootFormId="formData.root_parent_id"
              @selectedVersion="getFormData"
              :formId="formData.id"
              :viewOnly="true"
              :selectedTab="selectedTab"
            />
          </div>
          <div
            v-if="
              selectedTab === config.FORM_TAB_STATUS.WORKFLOW &&
              formTemplateData.id &&
              wftStartStages?.length
            "
            class="tab-body-parent"
          >
            <div
              class="create-form-step-selection"
              v-if="wftStartStages?.length > 1 && !selectedStartingStep"
            >
              <h4 class="mb-4 v-center space-between">
                Select start step for the workFlow
                <router-link
                  :to="`/workflows/${workflowData?.typeName}/?tid=${workflowData.id}`"
                  target="_blank"
                >
                  <button class="btn mr-3 v-center" v-overflow-tooltip="'View workflow'">
                    <img
                      src="~@/assets/images/icons/workflows.svg"
                      class="mx-2"
                      width="20px"
                      height="20px"
                      alt=""
                    />
                  </button>
                </router-link>
              </h4>
              <div class="create-form-step-selection-list">
                <div
                  class="create-form-step-selection-item"
                  v-for="stage in wftStartStages"
                  :key="stage.id"
                  @click="addSelectedStep(stage)"
                >
                  {{ stage.name }}
                </div>
              </div>
            </div>
            <div class="activeStep" v-else>
              <div class="space-between v-center my-2">
                <h3 class="weight-500 xl v-center">
                  <img
                    v-show="wftStartStages?.length > 1"
                    src="~@/assets/images/icons/arrow-back.svg"
                    width="20"
                    @click="selectedStartingStep = null"
                    class="mx-2"
                  />
                  Active Step
                </h3>
                <router-link
                  :to="`/workflows/${workflowData?.typeName}/?tid=${workflowData.id}`"
                  target="_blank"
                >
                  <button class="btn mr-3 v-center" v-overflow-tooltip="'View workflow'">
                    <img
                      src="~@/assets/images/icons/workflows.svg"
                      class="mx-2"
                      width="20px"
                      height="20px"
                      alt=""
                    /></button
                ></router-link>
              </div>

              <div class="grid-3 w-100">
                <span class="label">Name </span>
                <span>:</span>
                <span class="value elipsis-text">{{ selectedStartingStep?.name }}</span>
              </div>

              <div class="grid-3 w-100">
                <span class="label">Duration </span>
                <span>:</span>
                <span class="value"
                  >{{ selectedStartingStep?.duration }}
                  {{ config.DURATION_TYPE[selectedStartingStep?.duration_type] }}</span
                >
              </div>
              <div
                class="grid-3 w-100"
                v-if="selectedStartingStep?.core_user_group?.name"
              >
                <span class="label">Department </span>
                <span>:</span>
                <span class="value">{{
                  selectedStartingStep?.core_user_group?.name ?? "--"
                }}</span>
              </div>
              <!-- user selection startrs -->
              <div v-if="!isExternalCollaborator && prevInstanceusers !== null">
                <user-selection-for-wf
                  :selectedStartingStep="selectedStartingStep"
                  :selectedUserGroup="selectedUserGroup"
                  @handleUserSelection="handleUserSelection"
                  :selectedUsers="wFstepUsers"
                />
              </div>
              <!-- user selection ends -->
            </div>
          </div>
          <div v-if="selectedTab === config.FORM_TAB_STATUS.COMMENTS && parentFormId">
            <form-comment-panel
              :form="formData"
              :disabled="true"
              @closeComment="openComment = false"
              :closeOnOutsideClick="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDetailFormTemplate,
  SaveFormData,
  upadateMaterialForms,
  GetFormDataByFormId,
  reOpenForms,
  getGivenCustomListsData,
  getFlattenedBomMaterialsApi
} from '@/api'
import loadingCircle from '../../components/common/loadingCircle.vue'
// import { formValidationCheck } from './formValidationCheck'
import { alert, success } from '@/plugins/notification'
import { mapGetters } from 'vuex'
import config from '@/config'
import partIdPreview from '@/components/common/partIdPreview.vue'
import timeComponent from '@/components/form/elements/timeComponent.vue'
import configurationList from '@/components/form/elements/configurationList.vue'
import fileComponent from '@/components/form/elements/fileComponent.vue'
import dateComponent from '@/components/form/elements/dateComponent.vue'
import longTextComponent from '@/components/form/elements/longTextComponent.vue'
import numberComponent from '@/components/form/elements/numberComponent.vue'
import switchComponent from '@/components/form/elements/switchComponent.vue'
import textComponent from '@/components/form/elements/textComponent.vue'
import companyComponent from '@/components/form/elements/companyComponent.vue'
import userComponent from '@/components/form/elements/userComponent.vue'
import multiUserComponent from '@/components/form/elements/multiUserComponent.vue'
import materialComponent from '@/components/form/elements/materialComponent.vue'
import locationComponent from '@/components/form/elements/locationComponent.vue'
import productCodeComponent from '@/components/form/elements/productCodeComponent.vue'
import bomComponent from '@/components/form/elements/bomComponent.vue'
import tagsComponent from '@/components/form/elements/tagsComponent.vue'
import documentsComponent from '@/components/form/elements/documentsComponent.vue'
import factoryComponent from '@/components/form/elements/factoryComponent.vue'
import userSelectionForWf from '@/components/form/userSelectionForWf.vue'
import { GetFormValueMap } from '@/helper/formValue.js'
import versionHistory from './versionHistory.vue'
import Loader from '@/plugins/loader'
import { getAllStepAssignees, getWorkflowStepWithUsers } from '@/api/apis/workflows'
import confirmationDialog from '@/plugins/confirmationDialog'
import FormCommentPanel from '../../components/form/formCommentPanel.vue'
import tableTemplate from '../SETTINGS/tableTemplate.vue'
import errorBorder, { removeErrorBorder } from '@/helper/formValidation/errorBorder'
import { timeStampToDate } from '@/filters/dateFilter'

const componentAlignment = {
  BOOLEAN: 1,
  NUMBER: 1,
  TEXT: 1,
  LONG_TEXT: 2,
  DATE: 1,
  TIME: 1,
  CONFIGURATION_LIST: 1,
  ATTACHMENT: 2,
  COMPANY: 1,
  USER: 1,
  MULTI_USER: 2,
  MATERIALS: 2,
  LOCATION: 2,
  PRODUCT_CODE: 1,
  BOM: 2,
  TAGS: 2,
  CONTACT_LIST: 2,
  DOCUMENTS: 2,
  TABLE: 2
}

export default {
  components: {
    loadingCircle,
    BOOLEAN_COMPONENT: switchComponent,
    NUMBER_COMPONENT: numberComponent,
    TEXT_COMPONENT: textComponent,
    LONG_TEXT_COMPONENT: longTextComponent,
    DATE_COMPONENT: dateComponent,
    TIME_COMPONENT: timeComponent,
    CONFIGURATION_LIST_COMPONENT: configurationList,
    ATTACHMENT_COMPONENT: fileComponent,
    COMPANY_COMPONENT: companyComponent,
    USER_COMPONENT: userComponent,
    MULTI_USER_COMPONENT: multiUserComponent,
    MATERIALS_COMPONENT: materialComponent,
    LOCATION_COMPONENT: locationComponent,
    PRODUCT_CODE_COMPONENT: productCodeComponent,
    BOM_COMPONENT: bomComponent,
    TAGS_COMPONENT: tagsComponent,
    DOCUMENTS_COMPONENT: documentsComponent,
    TABLE_COMPONENT: tableTemplate,
    factoryComponent,
    versionHistory,
    userSelectionForWf,
    partIdPreview,
    FormCommentPanel
  },
  name: 'createForm',
  data () {
    return {
      partIdValues: [],
      partIdRules: [],
      currentDate: new Date().toLocaleDateString('en-CA'),
      templateId: '',
      templateName: '',
      formTemplateData: {},
      formTemplateVersion: {},
      loading: false,
      dueDate: '',
      validationErrors: '', // this is for getting valiadtion errors
      workFlowData: null,
      wftStartStages: [],
      selectedStartingStep: null,
      formValueData: {},
      selectedTab: 1,
      formData: {},
      parentFormId: this.$route.params.parentFormId,
      stepWithNoUsers: null,
      tabs: [
        {
          id: 1,
          name: 'WorkFlow'
        },
        {
          id: 2,
          name: 'Comments'
        },
        {
          id: 3,
          name: 'Version History'
        },
        {
          id: 4,
          name: 'History'
        }
      ],
      config: config,
      wFstepUsers: [], // this is used to store the users selected in the workflow step
      parentInstanceId: null, // only for reopend forms
      prevInstanceusers: this.$route.params.parentFormId ? null : [],
      selectedUserGroup: []
    }
  },
  computed: {
    ...mapGetters([
      'isOnProjectLevel',
      'tenantUsersList',
      'currentProject',
      'isExternalCollaborator'
    ]),
    visibleTabs () {
      return this.tabs.filter((tab) => {
        if (!this.wftStartStages?.length && tab.name === 'WorkFlow') return false
        if (!this.parentFormId && [2, 3, 4].includes(tab.id)) return false
        return true
      })
    },
    templateField () {
      const activeVersion =
        this.formTemplateData.template_versions.find((item) => item.active) || {}
      for (let i = 0; i < activeVersion.template_fields.length; i++) {
        if (activeVersion.template_fields[i].field_id === config.FACTORY_FIELD_ID) {
          const factoryField = activeVersion.template_fields.splice(i, 1)[0]
          activeVersion.template_fields.unshift(factoryField)
        }
      }
      return activeVersion.template_fields || []
    },
    materialId () {
      if (this.$route.params?.materialId) {
        return this.$route.params.materialId
      } else {
        return null
      }
    },
    isJofForm () {
      return this.formTemplateData.form_type === this.config.FORM_TEMPLATE_TYPE.JOF ||
        this.formTemplateData.core_form_type?.id === this.config.FORM_TEMPLATE_TYPE.JOF
    },
    disableSubmit () {
      return this.stepWithNoUsers?.length > 0
    },
    showSideBar () {
      return (this.formTemplateData.id && this.wftStartStages?.length) || this.parentFormId
    }
  },
  methods: {
    async validateTableComponent (component, options = { checkRequired: true }) {
      if (component?.$options?.name !== 'table-template') return true
      return component.saveFormTemplate(options)
    },
    setDefaultTab () {
      this.selectedTab = this.visibleTabs[0]?.id || null
    },
    getValuesFromForm (key) {
      key = key.toLowerCase()
      switch (key) {
      case 'created on':
      case 'created_on':
        return this.formData.created_on ? timeStampToDate(this.formData.created_on) : ''
      case 'created by':
      case 'created_by':
        return this.formData.created_by
          ? `${this.formData.created_by_user?.first_name || ''} ${this.formData.created_by_user?.last_name || ''}`.trim()
          : ''
      case 'updated_on':
      case 'updated on':
        return this.formData.updated_on ? timeStampToDate(this.formData.updated_on) : ''
      case 'updated_by':
      case 'updated by':
        return this.formData.updated_by
          ? `${this.formData.updated_by_user?.first_name || ''} ${this.formData.updated_by_user?.last_name || ''}`.trim()
          : ''
      default:
        return ''
      }
    },
    getComponentGridClass (key) {
      const span = componentAlignment[key] || 1
      return span === 2 ? 'form-grid__item--span-2' : 'form-grid__item--span-1'
    },
    updatePartIdValues (values) {
      this.partIdValues = values
    },
    getValidationSelector (formInput, form) {
      if (!formInput?.field_id) return null
      return form?.[formInput.field_id]?.[0]?.validationName || null
    },
    isFieldRequired (formInput) {
      return formInput?.required
    },
    setInputValidationState (formInput, form, hasError) {
      const selector = this.getValidationSelector(formInput, form)
      if (!selector) return
      if (hasError) {
        errorBorder(selector, true)
      } else {
        removeErrorBorder([selector])
      }
    },
    setFactoryValidationState (hasError) {
      const selector = this.$refs?.[config.FACTORY_FIELD_ID]?.[0]?.validationName
      if (!selector) return
      if (hasError) {
        errorBorder(selector, true)
      } else {
        removeErrorBorder([selector])
      }
    },
    highlightApiValidationErrors (errors = []) {
      errors.forEach((error) => {
        const field = this.templateField.find((item) => {
          return item.field_id === error.field_id ||
            item.field_id === error.fieldName ||
            item.field_name === error.field_name ||
            item.caption === error.field_name
        })
        const component = field?.field_id ? this.$refs[field.field_id]?.[0] : null
        const selector = component?.validationName || error.validationName
        if (selector) {
          errorBorder(selector, true, error.message)
        }
      })
    },
    getFieldCaption (error) {
      if (!error) return ''
      const field = this.templateField.find((item) => {
        return item.field_id === error.field_id ||
          item.field_id === error.fieldName ||
          item.field_name === error.field_name ||
          item.caption === error.field_name
      })
      return field?.caption || error.field_name || ''
    },
    goBack (e) {
      if (e instanceof KeyboardEvent && e.code !== 'Escape') {
        return
      }
      this.$router.go(-1)
    },
    getFormTemplateData () {
      this.loading = true
      getDetailFormTemplate(this.templateId, true).then(async (res) => {
        this.templateName = res.core_form_templates_by_pk.name
        this.formTemplateData = res.core_form_templates_by_pk
        if (
          res.core_form_templates_by_pk?.core_sequence_id_template?.id_generation_rules
        ) {
          this.partIdRules =
            res.core_form_templates_by_pk?.core_sequence_id_template?.id_generation_rules
        }
        this.formTemplateVersion = res.core_form_templates_by_pk?.template_versions.find(
          (version) => version.active
        )
        this.workflowData = {
          id: res.core_form_templates_by_pk.workflow_template_id,
          typeName: res.core_form_templates_by_pk.workflow_template?.type_value?.name,
          versionId:
            res.core_form_templates_by_pk?.workflow_template?.workflow_versions[0].id
        }
        this.wftStartStages =
          res.core_form_templates_by_pk?.workflow_template?.workflow_versions[0]?.workflow_stages
        const customListData = this.findUsedCustomListIds(
          res.core_form_templates_by_pk.template_versions
        )
        if (customListData.size > 0) {
          await this.getGivenCustomList([...customListData])
        }
        // to check with any steps without active users
        if (this.workflowData.versionId) {
          this.checkUsersAvailabilityWithWorkFlow()
        }
        if (this.wftStartStages?.length === 1) {
          this.selectedStartingStep = this.wftStartStages[0]
        }
        this.loading = false
      })
    },
    saveAsDraft () {
      if (this.isJofForm) {
        return this.saveasDraftForFB({})
      }
      const { inputPayload, factoryId, isValid } = this.formatFormData()
      if (!isValid) {
        return
      }
      const body = [
        {
          templateId: this.templateId,
          dueDate: this.dueDate,
          inputPayload: inputPayload,
          status: 2
        }
      ]
      if (factoryId) {
        body[0].factoryId = factoryId
      }
      const loader = new Loader()
      loader.show()
      SaveFormData(body, this.isOnProjectLevel)
        .then((res) => {
          const err = res.failedValidations || res.error || []
          if (err.length) {
            this.highlightApiValidationErrors(err)
            const fieldLabel = this.getFieldCaption(err[0])
            alert(fieldLabel ? `${fieldLabel}: ${err[0]?.message}` : `${err[0]?.message}`)
          } else if (res.message === 'Unable to save form') {
            alert(res.message)
          } else {
            success('Form saved as Draft')
            this.$router.push(`/forms/template/${this.templateId}/list`)
          }
        })
        .catch((err) => {
          console.log(err)
          alert('some thing went wrong')
        })
        .finally(() => {
          loader.hide()
        })
    },
    saveasDraftForFB ({ fieldId, submitAfterFlattening = false }) {
      this.loading = true
      const { inputPayload, factoryId, isValid } = this.formatFormData()
      if (!factoryId) {
        alert('Please select the Factory')
        this.setFactoryValidationState(true)
        this.loading = false
        return
      } else {
        this.setFactoryValidationState(false)
      }
      if (!isValid) {
        this.loading = false

        return
      }

      const body = {
        templateId: this.templateId,
        dueDate: this.dueDate,
        inputPayload: inputPayload,
        status: 2,
        factoryId: factoryId
      }

      getFlattenedBomMaterialsApi(body)
        .then((res) => {
          const formId = res.message?.id
          if (!formId) {
            throw new Error('Unable to Open flattened BOM')
          }
          this.loading = false
          if (fieldId) {
            this.$router.replace({
              path: `/forms/template/${this.templateId}/form/${formId}/edit`,
              query: {
                flattenedBom: fieldId,
                ...(submitAfterFlattening ? { submitJofForm: formId } : {})
              }
            })
          } else {
            success('Form saved as Draft')
            this.$router.push(`/forms/template/${this.templateId}/list`)
          }
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          alert('Unable to open flattened BOM')
        })
    },
    formatFormData () {
      const formValue = {}
      const form = this.$refs
      this.validationErrors = []
      if (this.dueDate === '') {
        this.validationErrors.push('Please select due date')
        errorBorder('dueDate', true)
      } else {
        removeErrorBorder(['dueDate'])
      }
      const inputPayload = []
      let factoryId = null
      for (const [key, value] of Object.entries(form)) {
        if (value?.length && value[0]?.data?.autogenerated === false) {
          formValue[key] = value[0].componentValue
        } else if (value[0]?.data?.field_id === config.FACTORY_FIELD_ID) {
          factoryId = value[0]?.componentValue
        }
      }
      for (const [key, value] of Object.entries(formValue)) {
        if (value !== undefined && value !== null) {
          if (value !== 0 && value?.length !== 0 && !Number.isNaN(value)) {
            inputPayload.push({
              field_id: key,
              value
            })
          }
        }
      }
      // if (!inputPayload.length) {
      //   this.validationErrors.push('Please fill atleast one field')
      // }
      if (this.validationErrors.length > 0) {
        this.validationErrors.forEach((error) => alert(error))
      }
      return {
        inputPayload,
        factoryId,
        isValid: this.validationErrors.length === 0
      }
    },
    reOpenForm () {
      const form = this.$refs
      const formValue = {}
      this.validationErrors = []
      for (const key of Object.keys(form)) {
        this.validateInputData(form[key][0]?.data, form)
        if (form[key].length && form[key][0]?.data?.autogenerated === false) {
          if (
            form[key][0]?.componentValue !== undefined &&
            form[key][0]?.componentValue !== null
          ) {
            formValue[key] = form[key][0].componentValue
          }
        }
      }
      if (this.dueDate === '') {
        this.validationErrors.push('Please select due date')
        errorBorder('dueDate', true)
      } else {
        removeErrorBorder(['dueDate'])
      }
      if (
        this.workflowData.id &&
        !this.selectedStartingStep?.id &&
        this.wftStartStages.length
      ) {
        this.validationErrors.push('Please select starting step for the workflow')
        // this.$refs.workflowStepSelection.style.border = '1px solid rgba(0, 0, 0, 0.7)'
      }
      // checking whether the step has users or not
      if (
        this.workflowData.id &&
        !this.selectedStartingStep?.core_user_group?.name &&
        !this.wFstepUsers?.length
      ) {
        this.validationErrors.push('Please select users for the next step')
      }
      // checking for first step confirmation  -- end
      if (this.validationErrors.length > 0) {
        this.validationErrors.forEach((error) => alert(error))
        return
      }
      const inputPayload = []
      Object.keys(formValue).forEach((key) => {
        if (formValue[key] !== undefined && formValue[key] !== null) {
          if (formValue[key] !== 0 && formValue[key].length !== 0) {
            inputPayload.push({
              field_id: key,
              value: formValue[key]
            })
          }
        }
      })
      const stepUsers = this.wFstepUsers.map((user) => {
        return {
          user_id: user.user_id,
          target_tenant_id: user.target_tenant_id,
          step_id: this.selectedStartingStep?.id
        }
      })
      if (this.prevInstanceusers) {
        this.prevInstanceusers.forEach((item) => {
          if (item.step_id === this.selectedStartingStep?.id) {
            return
          }
          stepUsers.push({
            user_id: item.user_id,
            target_tenant_id: item.target_tenant_id,
            step_id: item.step_id
          })
        })
      }
      const body = {
        cost_impact: false,
        schedule_impact: false,
        due_date: this.dueDate,
        form_id: this.parentFormId,
        input_payload: inputPayload,
        step_id: this.selectedStartingStep?.id ?? undefined,
        workflowStepAssignees: Array.isArray(this.wFstepUsers) ? stepUsers : []
      }
      const loader = new Loader()
      loader.show()
      reOpenForms(body, this.isOnProjectLevel)
        .then((res) => {
          const err = res.failedValidations || res.error || []
          if (err.length) {
            loader.hide()
            this.highlightApiValidationErrors(err)
            alert(`${err[0]?.message}`)
          } else {
            loader.hide()
            success('Form Updated successfully')
            this.$router.push(`/forms/template/${this.templateId}/list`)
          }
        })
        .catch(() => {
          loader.hide()
          alert('some thing went wrong')
        })
    },
    checkEmptyUserStepAndSubmit () {
      if (this.workflowData?.id && this.stepWithNoUsers?.length > 0) {
        confirmationDialog(
          `${this.stepWithNoUsers?.length} workflow steps have user groups with zero users from this project. Forms will be blocked at these steps until resolved.`,
          (res) => {
            if (res) {
              // this.submitForm()
            }
          }
        )
      } else if (this.parentFormId) {
        this.reOpenForm()
      } else {
        this.submitForm()
      }
    },
    openJofFlattenedBomForSubmit () {
      const materialField = this.templateField.find(
        (field) => field?.form_field?.key === 'MATERIALS'
      )
      if (!materialField?.field_id) {
        alert('Please add a material field to review flattened BOM')
        return
      }
      this.saveasDraftForFB({
        fieldId: materialField.field_id,
        submitAfterFlattening: true
      })
    },
    validatePartIdValues () {
      let isValid = true
      for (const value of this.partIdValues) {
        if (!value.value) {
          this.validationErrors.push(
            `Please enter a value for ${value.caption} in form id`
          )
          isValid = false
        }
      }
      return isValid
    },
    async submitForm () {
      const form = this.$refs
      const formValue = {}
      this.validationErrors = []
      if (this.partIdValues.length) {
        this.validatePartIdValues()
      }
      let factoryId = null
      for (const key of Object.keys(form)) {
        const component = form[key][0]

        this.validateInputData(form[key][0]?.data, form)
        if (component?.validateSelection) {
          const isSelectionValid = await component.validateSelection()
          if (!isSelectionValid) {
            this.validationErrors.push(`${component.data.caption} must use a last child selection`)
          }
        }
        if (component?.$options?.name === 'table-template') {
          const isValid = await this.validateTableComponent(component, { checkRequired: true })
          if (!isValid) {
            return
          }
        }
        if (form[key].length && form[key][0]?.data?.autogenerated === false) {
          if (
            form[key][0]?.componentValue !== undefined &&
            form[key][0]?.componentValue !== null
          ) {
            formValue[key] = form[key][0].componentValue
          }
        } else if (form[key][0]?.data?.field_id === config.FACTORY_FIELD_ID) {
          factoryId = form[key][0]?.componentValue
        }
      }
      if (this.dueDate === '') {
        this.validationErrors.push('Please select due date')
        errorBorder('dueDate', true)
      } else {
        removeErrorBorder(['dueDate'])
      }
      if (
        this.formTemplateData.core_form_type.id === config.FORM_TEMPLATE_TYPE.JOF &&
        !factoryId
      ) {
        this.validationErrors.push('Please select factory')
        this.setFactoryValidationState(true)
      } else {
        this.setFactoryValidationState(false)
      }
      // checking for first step confirmation  -start
      if (
        this.workflowData.id &&
        !this.selectedStartingStep?.id &&
        this.wftStartStages.length
      ) {
        this.validationErrors.push('Please select starting step for the workflow')
        // this.$refs.workflowStepSelection.style.border = '1px solid rgba(0, 0, 0, 0.7)'
      }
      // checking whether the step has users or not
      if (
        this.workflowData.id &&
        !this.selectedStartingStep?.core_user_group?.name &&
        !this.wFstepUsers?.length
      ) {
        this.validationErrors.push('Please select users for the next step')
      }
      // checking for first step confirmation  -- end
      if (this.validationErrors.length > 0) {
        this.validationErrors.forEach((error) => alert(error))
        return
      }
      // if (formValidationCheck(this.templateField, formValue)) {
      const inputPayload = []
      Object.keys(formValue).forEach((key) => {
        if (formValue[key] !== undefined && formValue[key] !== null) {
          if (formValue[key] !== 0 && formValue[key].length !== 0) {
            inputPayload.push({
              field_id: key,
              value: formValue[key]
            })
          }
        }
      })
      const stepUsers = this.wFstepUsers.map((item) => {
        return {
          user_id: item.user_id,
          target_tenant_id: item.target_tenant_id,
          step_id: this.selectedStartingStep?.id
        }
      })
      const body = [
        {
          templateId: this.templateId,
          dueDate: this.dueDate,
          inputPayload: inputPayload,
          status: 1,
          stepId: this.selectedStartingStep?.id ?? undefined,
          workflowStepAssignees: this.wFstepUsers.length ? stepUsers : undefined
        }
      ]
      if (factoryId) {
        body[0].factoryId = factoryId
      }
      if (this.partIdRules.length) {
        const sequenceInput = this.partIdValues.map((value) => {
          return {
            value: value.value,
            delimiter: value.delimiter === '' ? null : value.delimiter,
            sequence: value.sequence
          }
        })
        body[0].formSequencePayload = sequenceInput
      }
      const loader = new Loader()
      loader.show()
      SaveFormData(body, this.isOnProjectLevel)
        .then((res) => {
          const err = res.failedValidations || res.error || []
          if (err.length) {
            loader.hide()
            this.highlightApiValidationErrors(err)
            const fieldLabel = this.getFieldCaption(err[0])
            alert(fieldLabel ? `${fieldLabel}: ${err[0]?.message}` : `${err[0]?.message}`)
          } else if (res.message === 'Unable to save form') {
            loader.hide()
            alert(res.message)
          } else {
            const formId = res?.insertedFormIds[0]
            // this means you are uploading a material custom field form
            if (this.materialId) {
              upadateMaterialForms(this.materialId, formId)
                .then((res) => {
                  this.$router.go(-1)
                  loader.hide()
                  success('Custom fields are added successfully')
                })
                .catch(() => {
                  loader.hide()
                  alert('some thing went wrong')
                })
            } else {
              loader.hide()
              success('Form saved successfully')
              this.$router.push(`/forms/template/${this.templateId}/form/${formId}/view`)
            }
          }
        })
        .catch(() => {
          loader.hide()
          alert('some thing went wrong')
        })
    },
    validateInputData (formInput, form) {
      let hasError = false
      const isRequired = this.isFieldRequired(formInput)
      if (formInput?.form_field?.key === 'DOCUMENTS') {
        if (
          isRequired &&
          (!form[formInput.field_id][0].componentValue ||
            !form[formInput.field_id][0].componentValue.length)
        ) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
          hasError = true
        }
      }
      if (formInput?.form_field?.key === 'USER') {
        if (
          isRequired &&
          (!form[formInput.field_id][0].componentValue ||
            !form[formInput.field_id][0].componentValue.length)
        ) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
          hasError = true
        }
      }
      if (formInput?.form_field?.key === 'MULTI_USER') {
        if (
          isRequired &&
          (!form[formInput.field_id][0].componentValue ||
            !form[formInput.field_id][0].componentValue.length)
        ) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
          hasError = true
        }
        this.setInputValidationState(formInput, form, hasError)
        return
      }
      if (formInput?.form_field?.key === 'BOOLEAN') {
        // we are comparing the value to null instead of checking if it is a falsy value cause the boolean component value will false in one case and it is valid value
        if (isRequired && form[formInput.field_id][0].componentValue === null) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
          hasError = true
        }
        this.setInputValidationState(formInput, form, hasError)
        return
      } else if (formInput?.form_field?.key === 'MATERIALS') {
        const materialValue = form[formInput.field_id][0]?.componentValue || []
        if (
          isRequired &&
          (!Array.isArray(materialValue) || materialValue.length < 1)
        ) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
          hasError = true
        }
        this.setInputValidationState(formInput, form, hasError)
        return
      } else if (formInput?.form_field?.key === 'TAGS') {
        if (
          isRequired &&
          form[formInput.field_id][0].componentValue.length < 1
        ) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
          hasError = true
        }
        this.setInputValidationState(formInput, form, hasError)
        return
      } else if (
        formInput?.form_field?.key === 'CONFIGURATION_LIST' &&
        !form[formInput.field_id][0]?.componentValue.length &&
        isRequired
      ) {
        this.validationErrors.push(`${formInput.caption} is a mandatory field`)
        hasError = true
      }
      if (isRequired && !form[formInput.field_id][0].componentValue) {
        this.validationErrors.push(`${formInput.caption} is a mandatory field`)
        hasError = true
      }
      this.setInputValidationState(formInput, form, hasError)
    },
    addSelectedStep (stage) {
      this.selectedStartingStep = stage
      this.wFstepUsers = this.prevInstanceusers.filter(
        (item) => item.step_id === stage.id
      )
    },
    getFormData (form) {
      const updatedFormId = form ? form.id : this.parentFormId
      if (updatedFormId) {
        GetFormDataByFormId(
          updatedFormId,
          this.isOnProjectLevel,
          this.isExternalCollaborator
        ).then((res) => {
          this.formData = res.core_forms_by_pk
          this.parentInstanceId = res?.core_forms_by_pk?.workflow_instance_id || null
          const { formValueMap } = GetFormValueMap(res.core_forms_by_pk)
          this.formValueData = formValueMap
          this.dueDate = new Date(this.formData.due_date).toISOString().split('T')[0]
          this.getFormTemplateData()
          // to get all step assignees  from the previous form instances, works only  for reopend forms
          if (this.parentInstanceId) {
            this.getPreviousAllStepAssignees()
          }
        })
      }
    },
    checkUsersAvailabilityWithWorkFlow () {
      // const stepUserMap = {}

      getWorkflowStepWithUsers(this.workflowData.versionId).then((res) => {
        const stepUserMapSet = {}
        res.workflow_stages.forEach((stage) => {
          for (const userData of stage.core_user_group?.core_user_group_members ?? []) {
            this.selectedUserGroup.push(userData)
            if (stepUserMapSet[stage.id]) {
              stepUserMapSet[stage.id].add(userData.user_id)
            } else {
              stepUserMapSet[stage.id] = new Set([userData.user_id])
            }
          }
        })
        // checking for the first step with no users, respected stedid are stored
        const stepWithNoUsers = {}
        if (this.isOnProjectLevel) {
          for (const step in stepUserMapSet) {
            let confirmFlag = false
            for (const user of this.currentProject.project_user_associations) {
              if (stepUserMapSet[step].has(user.user_id)) {
                confirmFlag = true
                break
              }
            }
            if (!confirmFlag) {
              stepWithNoUsers[step] = step
            }
          }
        } else {
          for (const step in stepUserMapSet) {
            let confirmFlag = false
            for (const user of this.tenantUsersList) {
              if (stepUserMapSet[step].has(user.associated_user.id)) {
                confirmFlag = true
                break
              }
            }
            if (!confirmFlag) {
              stepWithNoUsers[step] = step
            }
          }
        }
        this.stepWithNoUsers = Object.keys(stepWithNoUsers)
        if (this.stepWithNoUsers?.length > 0) {
          confirmationDialog(
            `${this.stepWithNoUsers?.length} workflow steps have user groups with zero users from this project. Forms will be blocked at these steps until resolved`,
            (res) => {
              if (res) {
              }
            }
          )
        }
      })
    },
    findUsedCustomListIds (templateVersions) {
      const configIdSet = new Set()
      for (const templateVersion of templateVersions) {
        for (const field of templateVersion.template_fields) {
          if (field.field_type_id === config.FORM_TYPE.CONFIGRATION_LIST) {
            configIdSet.add(field.custom_list_id)
          }
        }
      }
      return configIdSet
    },
    async getGivenCustomList (ids) {
      const customListData = await getGivenCustomListsData(ids)
      const customListMap = {}
      for (const customList of customListData.core_custom_list) {
        customListMap[customList.id] = customList.custom_list_values
      }
      this.$store.dispatch('form/saveCustomListMap', customListMap)
    },
    handleUserSelection (data) {
      this.wFstepUsers = data.value.insert
    },
    // fetch all step assignees  from the previous form instances
    getPreviousAllStepAssignees () {
      if (!this.parentFormId) {
        return
      }
      getAllStepAssignees(this.parentInstanceId)
        .then((res) => {
          this.prevInstanceusers = res.instance_step_assignees.map((item) => {
            return {
              user_id: item.user_id,
              target_tenant_id: item.target_tenant_id,
              step_id: item.workflow_step_id
            }
          })
          if (this.selectedStartingStep?.id) {
            this.wFstepUsers = this.prevInstanceusers.filter(
              (item) => item.step_id === this.selectedStartingStep?.id
            )
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  mounted () {
    this.getFormData()
    this.setDefaultTab()
    // fetch all step assignees  from the previous form instances
  },
  created () {
    this.templateId = this.$route.params.templateId
    this.getFormTemplateData()
  },
  watch: {
    visibleTabs () {
      this.setDefaultTab()
    }
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 1600px) {
  .create-form--maincontainer {
    margin-right: auto;
    margin-left: auto;
    max-width: 1520px;
  }
  .no-wf-container{
    max-width: 800px;
  }
}

.create-form {
  // background: rgba(255, 196, 103, 0.05);
  &--nav {
    & input {
      border: var(--border);
      background-color: transparent;
      border-radius: 4px;
      padding: 4px 8px;
      height: 30px;
      width: 200px;
      outline: none;
      &:focus {
        border-color: var(--brand-color);
      }
    }
  }
  &--container {
    // padding: 20px;
    margin-top: 10px;
    flex: 1;
    min-width: 0;
    overflow-y: auto;
    background-color: var(--white);
  }
  &--elements {
    height: -webkit-fill-available;
    overflow-y: auto;
    padding: 4px;
  }
  // &-autogenerated {
  //   background-color: rgba(var(--brand-rgb), 0.2);
  //   padding: 10px;
  //   margin-bottom: 10px;
  //   border-radius: 5px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  //   flex-wrap: wrap;
  //   grid-gap: 10px;
  //   & .label {
  //     font-size: var(--text-base);
  //     color: var(--brand-color-1);
  //     font-weight: 500;
  //   }
  //   & .value {
  //     margin-left: 6px;
  //     font-size: var(--text-l);
  //     color: var(--text-color);
  //   }
  // }
  &--sideBar {
    // padding: 20px;
    margin-top: 10px;
    flex: 1;
    min-width: 0;
    height: calc(100%);
    border-radius: 6px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    // background: white;
    & .activeStep {
      display: flex;
      flex-direction: column;
      gap: 20px;
      box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
      padding: 20px;
      background: white;
      border-radius: 6px;
    }
  }
  &--maincontainer {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 20px;
    height: calc(100% - 60px);
    overflow: hidden;
  }
  &-step-selection {
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
    padding: 20px;
    background: white;
    border-radius: 6px;
    margin: 1px;
    &-list {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      justify-content: center;
    }
    &-item {
      border: 1px solid rgb(73, 73, 73, 0.3);
      padding: 10px 20px;
      border-radius: 5px;
      background-color: rgb(126, 172, 248, 0.6);
      font-size: 12x;
      color: black;
      cursor: pointer;
    }
  }
}

.create-form .form-autogenerated {
  border-radius: 5px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;

  .autogenerated,
  .span-div {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .label {
    color: var(--form-input-caption-color);
    font-size: var(--form-input-caption-size);
    font-weight: 600;
    margin-bottom: 4px;
  }

  .value {
    background-color: rgb(173 208 250 / 40%);
    border: var(--form-input-border);
    border-color: rgba(151, 179, 249, 0.38);
    border-radius: var(--form-input-border-radius);
    color: #3046ea;
    font-size: var(--form-input-font-size);
    min-width: 0;
    overflow-wrap: anywhere;
    padding: 5px 8px;
  }
}

// .form-grid {
//   display: grid;
//   grid-template-columns: repeat(2, minmax(0, 1fr));
//   gap: 12px 18px;
//   align-items: start;
// }

// .form-grid__item {
//   display: flex;
//   flex-direction: column;
//   gap: 8px;
//   min-width: 0;
//   width: 100%;
// }

// .form-grid__item--span-1 {
//   grid-column: span 1;
// }

// .form-grid__item--span-2 {
//   grid-column: 1 / -1;
// }

.create-form .form-grid__item {
  min-width: 0;
}

.create-form .form-grid__item ::v-deep .form-input {
  width: 100%;
}

.create-form .form-grid__item ::v-deep .form-input__label {
  min-height: 18px;
  line-height: 18px;
  margin-bottom: 6px;
}

.create-form .form-grid__item ::v-deep .form-input__caption {
  line-height: 18px;
}

.create-form .form-grid__item ::v-deep .form-input input,
.create-form .form-grid__item ::v-deep .form-input select {
  height: 38px;
  min-height: 38px;
}

.create-form .form-grid__item ::v-deep .form-input textarea {
  min-height: 120px;
}

.create-form .form-grid__item ::v-deep .dateComponent label {
  font-size: var(--form-input-caption-size);
}

.tabs {
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  font-family: sans-serif;
}

.tab-headers {
  display: flex;
  font-size: var(--text-xs2);
  background-color: #f1f1f1;
  border-bottom: 1px solid #ccc;
}
.tab-body-parent {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: -webkit-fill-available;
  overflow: auto;
}
.tab-header {
  padding: 12px 18px;
  cursor: pointer;
  flex: 1;
  text-align: center;
  transition: background 0.3s;
}

.tab-header:hover {
  background-color: #e0e0e0;
}

.tab-header.active {
  background-color: #fff;
  font-weight: 500;
  border-bottom: 2px solid var(--brand-color);
}
.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  align-items: center;
  & .label {
  }
  & .value {
  }
}

@media (max-width: 500px) {
  .create-form--maincontainer {
    flex-direction: column;
    padding: 12px;
    overflow: auto;
  }

  .create-form--container,
  .create-form--sideBar {
    max-width: none;
    width: 100%;
  }

  .create-form .form-grid {
    grid-template-columns: minmax(0, 1fr) !important;
  }

  .create-form .form-autogenerated {
    grid-template-columns: minmax(0, 1fr);
  }

  .create-form .form-grid__item,
  .create-form .form-grid__item--span-1,
  .create-form .form-grid__item--span-2 {
    grid-column: 1 / -1 !important;
  }
}
</style>
